import React from 'react'
import './index.css'

const Spinner = () => {
  return (
    <div className="lds-span">
      <div className="lds-spinner">
        <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
      </div>
    </div>
  )
}

export default Spinner